export const messages = {
    nb: {
      Header1: `Kundeportal Kreditorforeningen!`,
      Paragraph1: `Velkommen til Kreditorforeningens kundeportal, klikk login for å logge deg på.`,      
    }
  } 